import React, {useEffect, useState} from 'react';
import Waves from "../components/heroWawes";
import WaveGrid from "../components/heroWawes";
import CoreLoader from "../components/CoreLoader/CoreLoader";
import axios from "axios";

const DemoPage = () => {

    const [loading, setLoading] = useState(true);
    useEffect(() => {

        const loadFontsAndDelay = async () => {
            if (document.fonts) {
                try {
                    await document.fonts.ready;
                } catch (e) {
                    console.warn("Fonts failed to load", e);
                }
            }

            const MIN_LOADER_TIME = 1000;
            await new Promise((resolve) => setTimeout(resolve, MIN_LOADER_TIME));

            setLoading(false);
        };

        loadFontsAndDelay();
    }, []);
    useEffect(() => {
        axios.post("https://api.undura.com/api/v1/contact", {
            full_name: "string",
            email: "prodseoy@gmail.com",
            message: "string",
            honeypot:""
        }).then(r => console.log(r))
        axios.post("https://api.undura.com/api/v1/newsletter/subscribe", {
            email: "prodseoy@gmail.com",
            honeypot:""
        }).then(r => console.log(r))
    }, [])

    return (
        <div className = "demo_page" >
           <CoreLoader visible={loading} onFinish={() => setLoading(false)} />

        </div>
    );
};

export default DemoPage;